import Image from "next/image";
import Link from "next/link";

import { formatPostDate } from "./format";

export interface BlogCardPost {
  slug: string;
  title: string;
  description: string;
  author: string;
  authorImage?: string;
  publishedAt: string;
  image?: string;
  image_alt?: string;
}

export function BlogCard({ post }: { post: BlogCardPost }) {
  return (
    <Link
      href={`/blog/${post.slug}`}
      className="group flex w-full flex-col gap-4"
    >
      <div className="border-marketing-border bg-marketing-cream-light relative aspect-[1200/670] overflow-hidden rounded-lg border">
        {post.image ? (
          <Image
            src={post.image}
            alt={post.image_alt || post.title}
            fill
            sizes="(min-width: 1024px) 400px, (min-width: 640px) 50vw, 100vw"
            className="object-cover transition-transform duration-500 group-hover:scale-[1.02] motion-reduce:transition-none"
          />
        ) : null}
      </div>
      <div className="flex flex-1 flex-col gap-2">
        <h3 className="text-marketing-text text-[20px]! leading-[1.3]! font-medium! tracking-[-0.01em]! text-pretty">
          {post.title}
        </h3>
        <p className="text-marketing-text-muted line-clamp-3 text-[15px] leading-[1.6]">
          {post.description}
        </p>
      </div>
      <p className="text-marketing-text-muted text-[13px]">
        {post.author} · {formatPostDate(post.publishedAt)}
      </p>
    </Link>
  );
}
